import { useEffect, useState } from "react";
import { Button } from "primereact/button";

import { Divider } from "primereact/divider";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import Loading from "../common/Loading";
import NoContent from "../common/NoContent";
import PageTitle from "../common/PageTitle";
import TabHeader from "../common/TabHeader";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { TEXT_NORMAL } from "../../style";
import FieldNote from "./common/FieldNote";

export default function WebsiteFooter() {
    const { requestAPI, showToast } = useAppContext();
    const [loading, setLoading] = useState();
    const [saving, setSaving] = useState();
    const [error, setError] = useState();
    const [record, setRecord] = useState();

    useEffect(() => {
        requestAPI({
            requestPath: "website/footer",
            requestMethod: "GET",
            setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (data && responseCode === 200) setRecord(data);
                else setError("Couldn't load Footer");
            },
        });
    }, [requestAPI]);

    const saveRecord = () => {
        requestAPI({
            requestPath: "website/footer",
            requestMethod: "PATCH",
            requestPostBody: record,
            setLoading: setSaving,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Footer !", life: 2000 }),
            onResponseReceieved: (updated, responseCode) => {
                if (updated && responseCode === 200) {
                    setRecord(updated);
                    showToast({ severity: "success", summary: "Updated", detail: "Footer Updated", life: 1000 });
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: updated?.error || "Failed To Update Footer !", life: 2000 });
                }
            },
        });
    };

    return (
        <div className="flex flex-column h-full">
            <PageTitle title="Footer" />
            <TabHeader
                className="px-3 pt-3"
                title="Footer text"
                highlights={["The short paragraph and the copyright line at the bottom of every page", "The link columns are edited under Menu links"]}
            />
            <Divider />
            {loading ? <Loading /> : null}
            {error ? <NoContent error={error} /> : null}
            {!loading && !error && record ? (
                <div className="flex-1 overflow-y-scroll p-3 flex flex-column">
                    <div>
                        <FloatLabel className="mt-5">
                            <InputTextarea id="footer_description" className="w-full" rows={4} autoResize value={record?.footer_description || ""} onChange={(event) => setRecord((prev) => ({ ...prev, footer_description: event.target.value }))} disabled={saving} />
                            <label htmlFor="footer_description">Short description</label>
                        </FloatLabel>
                        <FieldNote text="Required. The paragraph under the logo in the footer." />
                    </div>
                    <div>
                        <FloatLabel className="mt-5">
                            <InputText id="footer_copyright" className="w-full" value={record?.footer_copyright ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, footer_copyright: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                            <label htmlFor="footer_copyright">Copyright line</label>
                        </FloatLabel>
                        <FieldNote text="Write {{year}} where the current year should appear. Example: ? {{year}} SAHAS Institute of Commerce. All rights reserved." />
                    </div>
                    <Button className="mt-5 align-self-start" label="Save" icon="pi pi-check" loading={saving} onClick={saveRecord} />
                </div>
            ) : null}
        </div>
    );
}
